export default "__VITE_ASSET__BOCT92Ff__"